



































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Card } from 'element-ui';
import QuoteItem from '@/components/inquiry/quote/QuoteItem.vue';
import QuoteSettings from '@/components/inquiry/quote/QuoteSettings.vue';
import { fetchQuotes_inquiries_quotes } from '@/types/graphql/schemaTypes';
import { i18n } from '@/plugins/i18n';
import get from 'lodash/get';

@Component({
  components: {
    QuoteItem,
    QuoteSettings,
    'el-card': Card
  }
})
export default class QuotesCalculator extends Vue {
  private quotes: fetchQuotes_inquiries_quotes[] = [];
  private selected = '';
  private selectedQuote = '';

  private created() {
    this.$store.dispatch('Inquiry/setSimulation', false);
    this.fetchQuotes();
  }

  private fetchQuotes() {
    this.$store.dispatch('Inquiry/fetchQuotes', { inquiryId: this.$route.params.id });
  }

  private isApplied(quoteId: string) {
    return get(this.$store.state.Inquiry, 'quotes.selectedQuote.id', null) === quoteId;
  }

  private addQuote() {
    this.$store.dispatch('Inquiry/upsertQuote', { shipmentId: this.$route.params.id }).then(() => {
      this.$store.dispatch('Alert/addAlert', {
        type: 'success',
        message: i18n.t('success.added'),
        time: 5000
      });
    });
  }

  private select(selection: string) {
    this.selected = selection;
  }

  @Watch('$store.state.Inquiry.generatedQuote.selectedQuote')
  setSelectedQuotes(selectedQuote: { id: string } | null) {
    if (selectedQuote && selectedQuote.id) {
      this.selectedQuote = selectedQuote.id;
      if (this.selected === '') {
        const finderMethod = (quote: fetchQuotes_inquiries_quotes) => {
          return quote.id === selectedQuote.id;
        };
        this.selected = this.$store.state.Inquiry.generatedQuote.quotes.findIndex(finderMethod);
      }
    } else {
      this.selectedQuote = '';
    }
  }
}
